import { Outlet } from 'react-router-dom';
import { Box } from 'style-utils/components/Box';
import Flex from 'style-utils/components/Flex';

const ErrorPageLayout = () => {
  return (
    <Flex w="100%" minH="100vh" flexDirection="column">
      <Box role="heading" aria-level={1} h="4rem" bg="white" />
      <Outlet />
      <Box as="footer" h="4rem" bg="bgPrimary" />
    </Flex>
  );
};

export default ErrorPageLayout;
